/*global chrome*/
import React from 'react';
import { Link} from 'react-router-dom';
import Slider from "react-slick";
import API,{base} from "../../api.js";
// import RightArrowIcon from "../../assets/images/web-new-images/right-arrow.svg";


const TestimonialSlider = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3.5,
  slidesToScroll: 1,
  // autoplay: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 3000,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1200, 
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767, 
      settings: {
        slidesToShow: 1,
      },
    },
  ],
}; 


class GraciousTestimonial extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list:[]
        }
    }
    componentDidMount() {
        API({
              method: 'GET',
              url: "testimonial/list",
              data:'json',
            }).then(data => {
              this.setState({list:data.data.response.data});
            }).catch(()=>{
                this.setState({lockSubmit:false});
            });
    }   
 render(){ 
	return (
	<section className="testimonials-section left-arrow-slider gracious-testimonial">      
        <h2 className="primary-heading text-center">Student <span>Testimonials</span></h2>
        <Slider {...TestimonialSlider}>
              <div className="testimonials-content">
                  <p>Highly recommend Language Academy for NAATI...✌🏻😊 The best institute I have ever come across!!! Always been grateful for being part of LA!</p>
                  <div className='user-info'>
                      <div className="user-img-outer">
                          <img className='user-img' src="/images/web-new-images/icons/user-profile-icon.jpg" alt="testimonial" />
                      </div>
                      <h3 className='user-name'>Jashan Gill</h3>
                  </div>
              </div>              
              <div className="testimonials-content">
                  <p>Thanks LA team for guidance in NAATI preparation, all staff members are very polite and give us a personal attention in each matter.really appreciate their help</p>
                  <div className='user-info'>
                      <div className="user-img-outer">
                          <img className='user-img' src="/images/web-new-images/icons/user-profile-icon.jpg" alt="testimonial" />
                      </div>
                      <h3 className='user-name'>Shiva Patel</h3>
                  </div>
              </div>              
              <div className="testimonials-content">
                  <p>Best coaching center for Naati...highly highly recommend</p>
                  <div className='user-info'>
                      <div className="user-img-outer">
                          <img className='user-img' src="/images/web-new-images/icons/user-profile-icon.jpg" alt="testimonial" />
                      </div>
                      <h3 className='user-name'>Paramjit Kaur Sandhu</h3>
                  </div>
              </div>              
              <div className="testimonials-content">
                  <p>Highly recommended to join LA. I cleared Naati and Pte with the help of LA team</p>
                  <div className='user-info'>
                      <div className="user-img-outer">
                          <img className='user-img' src="/images/web-new-images/icons/user-profile-icon.jpg" alt="testimonial" />
                      </div>
                      <h3 className='user-name'>Ajay Shankar Reddy</h3>
                  </div>
              </div>              
        </Slider>
        <div className="d-flex justify-content-center">
          <Link className="primary-btn" to="/auth/register">
          <span className="btn-inner">
              REGISTER NOW
              <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
          </span>
          </Link>
        </div> 
    </section>
	);
}
}

export default GraciousTestimonial;